// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { onMessage } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyDjLWuYNxg8SgVPNZAs_g6BSLMSjWHCMBk",
  authDomain: "rndsan-4d570.firebaseapp.com",
  storageBucket: "rndsan-4d570.firebasestorage.app",
  projectId: "rndsan-4d570",
  messagingSenderId: "995764885017",
  appId: "1:995764885017:web:501531623a82269284bc88"
};

{
//      apiKey: "AIzaSyDjLWuYNxg8SgVPNZAs_g6BSLMSjWHCMBk",
//   authDomain: "rndsan-4d570.firebaseapp.com",
//   projectId: "rndsan-4d570",
//   storageBucket: "rndsan-4d570.firebasestorage.app",
//   messagingSenderId: "995764885017",
//   appId: "1:995764885017:web:501531623a82269284bc88",
//   measurementId: "G-2PG5S9H3Y5"
}


const requestNotificationPermission = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    console.log("Notification permission granted.");
    return true;
  } else {
    console.log("Notification permission denied.");
    return false;
  }
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getDeviceToken = async () => {
    await requestNotificationPermission()
  try {
    const token = await getToken(messaging, {
      vapidKey: "BN8HxiR3qYdyjnW0Q4g6VUhivmhxc7f2bEjkeOIWLTeP3nJUHawxw1ME6u7Fi-ozIjlsbpFwNatqU4EbI5pKhHw" // from Firebase console
    });
    console.log("token  generated",token);
    
    return token; // Send this to backend
  } catch (err) {
    console.error("Error getting device token", err);
    return null;
  }
};




export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });